export default class UserDoesNotHaveAnyEmail extends Error {
  constructor() {
    super()
    Object.setPrototypeOf(this, UserDoesNotHaveAnyEmail.prototype)
  }
}
